import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import CustomCursor from '../CustomCursor';
import Div from '../Div';
import Footer from '../Footer';
import Header from '../Header';

export default function Layout({ headerVariant ,footer,open, setOpen}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header variant={headerVariant} open={open} setOpen={setOpen} />
      <Outlet />
      <CustomCursor />
      {footer && <Footer />}
      {/* On every page: carriers checking our texting registration look for
          the company name on the site. */}
      <Div className="container">
        <Div className="cs-bottom_footer">
          <Div className="cs-copyright">
            © {new Date().getFullYear()} Progressive Venture LLC. Skew is operated by Progressive Venture LLC.
          </Div>
        </Div>
      </Div>
    </>
  );
}
